import { useNavigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { ThemeProvider } from "styled-components";
import { latamB2b } from "@hangar/themes/core/web/latamB2b";
import { CustomNavigationClient } from "./utils/navigation";
import { AppRouter } from "./router/AppRouter";
import { I18nLoader } from "./components/i18n";

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);
  return (
    <MsalProvider instance={pca}>
      <ThemeProvider theme={latamB2b}>
        <I18nLoader>
          <AppRouter />
        </I18nLoader>
      </ThemeProvider>
    </MsalProvider>
  );
}

export default App;
